import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=3d5b00bc"
import script from "./organizations.ts?vue&type=script&lang=js&external"
export * from "./organizations.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports